import { Text } from "@clipboard-health/ui-components";
import { Alert, Stack } from "@mui/material";

export function ShiftTransferExpiredScreen() {
  return (
    <Stack alignItems="center" sx={{ height: "100%", justifyContent: "space-evenly" }}>
      <Alert severity="warning" variant="filled">
        This Shift Transfer Request expired.
      </Alert>

      <Text variant="body1">
        Please ask the current Shift holder to genereate a new Transfer Request.
      </Text>
    </Stack>
  );
}
